import React, { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../AreaPriceDetails/AreaPriceDetails.css";
import Base from "../admin_components/Admin_Base";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import Swal from "sweetalert2";
// import { useAuth } from "../Auth/useAuth";
// import useAxios from '../Auth/useAxios'
import authAxios from "../Auth/useAxios";
// import axios from "axios";
// import { useApi } from "../Auth/useAxios";
// import { useAuth } from "../Auth/useAuth";
// import { useAuth } from "../Auth/useAuth";

const AddPlotGrid = () => {
  // const { getToken } = useAuth();
  // const token = getToken();
  // const api = useApi();

  const [plotList, setPlotList] = useState([]);
  const [formData, setFormData] = useState({
    phase: "",
    plotNumber: "",
    plotDirection: "",
    area: "",
    plotAmount: "",
    active: true,
  });
  const [areas, setAreas] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  const Phases = ["Phase_1", "Phase_2", "Phase_3", "Phase_4"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "area") {
      setFormData((prevState) => ({
        ...prevState,
        area: { id: value },
      }));
    }
  };

  const handleAddPlot = () => {
    if (editIndex !== null) {
      const updatedPlots = [...plotList];
      updatedPlots[editIndex] = formData;
      setPlotList(updatedPlots);
      setEditIndex(null);
    } else {
      setPlotList([...plotList, formData]);
    }
    setFormData({
      phase: "",
      plotNumber: "",
      plotDirection: "",
      area: "",
      plotAmount: "",
    });
  };

  const handleEditPlot = (index) => {
    const selectedPlot = plotList[index];
    setFormData({
      ...selectedPlot,
      area: selectedPlot.area || { id: "" },
    });
    setEditIndex(index);
  };

  const handleDeletePlot = (index) => {
    const updatedPlots = plotList.filter((_, i) => i !== index);
    setPlotList(updatedPlots);
    setFormData({
      phase: "",
      plotNumber: "",
      plotDirection: "",
      area: "",
      plotAmount: "",
    });
  };
  useEffect(() => {
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    const response = await authAxios.get(
      `${ADMIN_API_BASE_URL}/main/admin/areas`
    );

    setAreas(response.data);
  };

  const handleSubmitAll = async () => {
    try {
      const response = await authAxios.post(
        `${ADMIN_API_BASE_URL}/main/admin/add-list-plots`,
        plotList
      );

      setPlotList([]);
      setFormData({
        phase: "",
        plotNumber: "",
        plotDirection: "",
        area: "",
        plotAmount: "",
      });
      Swal.fire("Success", "Plots added successfully!", "success");
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "An error occurred.",
        "error"
      );
    }
  };

  return (
    <Base>
      <div className="container res_container">
        <div className="pt-3 mt-5 addarea_labels pr-3">
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              key="1"
              color="inherit"
              href="/admin/dashboard"
              sx={{ color: "darkslategrey", fontWeight: "bold" }}
            >
              Dashboard
            </Link>
            <Link
              underline="hover"
              key="3"
              color="inherit"
              href="/admin/add_area"
              sx={{ color: "darkslategrey", fontWeight: "bold" }}
            >
              Add_Plot
            </Link>
          </Breadcrumbs>
        </div>
        <div>
          <h2 className="text-center fw-bold main_heading">Add Plot</h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} className="ad_hor_line" />
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAddPlot();
            }}
          >
            <div className="form-group px-3 mt-4">
              <div className="row pb-3">
                <div className="col-sm-3 addarea_labels">
                  <label className="col-form-label fw-bold">Add Phase:</label>
                </div>
                <div className="col-sm-7">
                  <select
                    id="phase"
                    name="phase"
                    className="form-control"
                    value={formData.phase}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Phase</option>
                    {Phases.map((phase, index) => (
                      <option key={index} value={phase}>
                        {phase}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row pb-3">
                <div className="col-sm-3 addarea_labels">
                  <label className="col-form-label fw-bold">Plot No:</label>
                </div>
                <div className="col-sm-7">
                  <input
                    type="text"
                    name="plotNumber"
                    className="form-control"
                    value={formData.plotNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row pb-3">
                <div className="col-sm-3 addarea_labels">
                  <label className="col-form-label fw-bold">
                    Plot Direction:
                  </label>
                </div>
                <div className="col-sm-7">
                  <input
                    type="text"
                    name="plotDirection"
                    className="form-control"
                    value={formData.plotDirection}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row pb-3">
                <div className="col-sm-3 addarea_labels">
                  <label className="col-form-label fw-bold">Area</label>
                </div>
                <div className="col-sm-7">
                  <select
                    name="area"
                    className="form-control w-100%"
                    style={{ display: "inline-block", minWidth: "100%" }}
                    value={formData.area ? formData.area.id : ""}
                    onChange={(e) => {
                      const selectedArea = areas.find(
                        (area) => area.id === parseInt(e.target.value)
                      );
                      setFormData((prevState) => ({
                        ...prevState,
                        area: selectedArea || null,
                      }));
                    }}
                    required
                  >
                    <option value="">Select Area</option>
                    {areas.length > 0 &&
                      areas.map((area) => (
                        <option key={area.id} value={area.id}>
                          {area.area}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="row pb-3">
                <div className="col-sm-3 addarea_labels">
                  <label className="col-form-label fw-bold">Plot Amount:</label>
                </div>
                <div className="col-sm-7">
                  <input
                    type="text"
                    name="plotAmount"
                    className="form-control"
                    value={formData.plotAmount}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button type="submit" className="btn submit_btn">
                {editIndex !== null ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        {/* Plot List */}
        {plotList.length > 0 && (
          <div className="pt-5">
            <h4
              className="text-center fw-bold"
              style={{ color: "darkslategrey" }}
            >
              Plot List
            </h4>
            <table className="table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Phase</th>
                  <th>Plot No</th>
                  <th>Plot Direction</th>
                  <th>Area</th>
                  <th>Plot Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {plotList.map((plot, index) => (
                  <tr key={index}>
                    <td>{plot.id}</td>
                    <td>{plot.phase}</td>
                    <td>{plot.plotNumber}</td>
                    <td>{plot.plotDirection}</td>
                    <td>{plot?.area ? plot?.area?.area : ""}</td>
                    {/* Render the 'id' of area */}
                    <td>{plot.plotAmount}</td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEditPlot(index)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeletePlot(index)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="d-flex justify-content-center pt-3">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmitAll}
              >
                Submit All
              </button>
            </div>
          </div>
        )}
      </div>
    </Base>
  );
};

export default AddPlotGrid;
